import { createStyles } from '@material-ui/core';

export default () =>
  createStyles({
    content: {
      maxHeight: 600,
    },
    paper: {
      overflowY: 'hidden',
    },
    rootPadding: {
      padding: 0,
    },
  });
